const iso = (d) => d.toISOString().slice(0, 10);
const shift = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };

// Current + best consecutive-day streaks from a Set of ISO dates (streak ends today or yesterday).
export const streakStats = (days, todayStr) => {
  let cur = 0;
  let d = new Date(todayStr);
  if (!days.has(todayStr)) d = shift(d, -1);
  while (days.has(iso(d))) { cur += 1; d = shift(d, -1); }
  let best = 0;
  days.forEach((s) => { if (!days.has(iso(shift(new Date(s), -1)))) { let n = 0; let x = new Date(s); while (days.has(iso(x))) { n += 1; x = shift(x, 1); } best = Math.max(best, n); } });
  return { cur, best: Math.max(best, cur) };
};

// Mirrors backend streak_bonus(): 1-2 +1 · 3-6 +2 · 7-13 +3 · 14-29 +4 · 30+ +5
export const streakBonus = (s) => (s >= 30 ? 5 : s >= 14 ? 4 : s >= 7 ? 3 : s >= 3 ? 2 : s >= 1 ? 1 : 0);

export const entryDays = (entries) => new Set((entries || []).map((e) => e.date).filter(Boolean));

// Live O-Rank: server ratings + client-side streak so it updates the instant a rep is logged.
export const liveORank = (ratings, streak) => {
  if (!ratings) return null;
  const keys = ["dribbling", "ball_control", "shooting", "ball_mastery"];
  const vals = keys.map((k) => ratings[k]?.value ?? 0);
  const base = Math.round(vals.reduce((a, b) => a + b, 0) / keys.length);
  const bonus = streakBonus(streak);
  return { base, bonus, orank: Math.min(99, base + bonus), streak };
};
